import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PingOneSignalsWebSdkService {
  private initialized = false;
  private initPromise: Promise<void> | null = null;
  private cachedData: string | null = null;
  private signals:
    | typeof import('@ping-identity/pingone-signals-web-sdk').default
    | null = null;

  constructor() {
    this.initPromise = this.init();
  }

  private async init(): Promise<void> {
    if (this.initialized) return;

    const module = await import('@ping-identity/pingone-signals-web-sdk');
    this.signals = module.default;

    await this.signals.init({
      behavioralDataCollection: true,
      consoleLogEnabled: false
    });
    this.initialized = true;
  }

  async getData(forceRefresh = false): Promise<string> {
    await this.initPromise;
    if (this.cachedData && !forceRefresh) {
      return this.cachedData;
    }
    return this.fetchAndCacheData();
  }

  private async fetchAndCacheData(): Promise<string> {
    if (!this.signals) {
      throw new Error('PingOne Signals SDK not initialized');
    }
    const data = await this.signals.getData();
    this.cachedData = typeof data === 'string' ? data : JSON.stringify(data);
    return this.cachedData;
  }

  clearCache(): void {
    this.cachedData = null;
  }

  pauseBehavioralData(): void {
    this.signals?.pauseBehavioralData();
  }

  resumeBehavioralData(): void {
    this.signals?.resumeBehavioralData();
  }
}
